export default __webpack_public_path__ + "4d9fb06b89b21176fa845cebba1d9760.png";